import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const CategoryUpdateContent = lazy(() => import('../../../../components/Pages/Categories/[categoryId]/Update'));

export default function CategoryUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: Tipping category update`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <CategoryUpdateContent />
      </Suspense>
    </Layout>
  );
}
